import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/spots/ondverdarnes-svortuloft-hero-thumb.webp")